<template>

  <div>
    <key-pad />
    <connected-call-list :type="type" />
    <transfer-keypad />
  </div>

</template>

<script>

import KeyPad from './components/keypad';
import TransferKeypad from "./components/transfer-keypad";
import ConnectedCallList from './components/connected-call-list';

export default {
  name: 'SalesforceDialer',
  components: {KeyPad, ConnectedCallList, TransferKeypad},
  props: {
    type: {required: true}
  }
}

</script>
